export const BASE_URL = "https://retailportalapi.webddocsystems.com/api/specialist/";
